import { DefaultService } from '@/services/DefaultService';

export default class AssClientePrazoPagamentoB2BEmpresaService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAll(column, order, page, limit, situacao, idEmpresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/b2b/b2bempresa/cliente/assprazopagto.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idEmpresa=${idEmpresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
	}

    findAllCombo(idEmpresa = 0, ...params) {
		return this._http.get(encodeURI(`${this._env}/b2b/b2bempresa/cliente/prazopagto/getcombo/b2bempresas.json?idempresa=${idEmpresa}&param=${params}`), this._headers).then(res => {
      return res.body;
		}, err => {
            this.handleError(err);
		});
	}

    find(id) {
		return this._http.get(`${this._env}/b2b/b2bempresa/cliente/assprazopagto/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
	}

    updateSituacao(assClientePrazoPagtoB2BEmpresa) {
        const { idb2b_assempresaclienteprazopagto: idB2BEmpresaClientePrazoPagamento, ...rest } = assClientePrazoPagtoB2BEmpresa;

        return this._http.post(`${this._env}/b2b/b2bempresa/cliente/assprazopagto/updatesituacao`, { idB2BEmpresaClientePrazoPagamento, ...rest }, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }

    save(assClientePrazoPagtoB2BEmpresa) {
        return this._http.post(`${this._env}/b2b/b2bempresa/cliente/assprazopagto`, assClientePrazoPagtoB2BEmpresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }

    insertBulk(assClientePrazoPagtoB2BEmpresa) {
        return this._http.post(`${this._env}/b2b/b2bempresa/cliente/assprazopagto/insert-bulk`, assClientePrazoPagtoB2BEmpresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }
}